import { FinanceIncompleteActionItemTemplate, IEntityTerminationActionItem } from '../types';

export const isStatToolActionItem = (item: IEntityTerminationActionItem): boolean =>
  item.description === FinanceIncompleteActionItemTemplate.StatToolOpenProcesses;

export const getSapActionItems = (
  actionItems: IEntityTerminationActionItem[],
): IEntityTerminationActionItem[] => actionItems.filter((item) => !isStatToolActionItem(item));

// Only SAP Deactivation action items and their tasks gate approval; Stat Tool items never do.
export const hasIncompleteSapActionItems = (actionItems: IEntityTerminationActionItem[]): boolean =>
  getSapActionItems(actionItems).some(
    (item) => !item.dateCompleted || (item.tasks ?? []).some((task) => !task.completedDate),
  );

export const areSapActionItemsComplete = (actionItems: IEntityTerminationActionItem[]): boolean =>
  getSapActionItems(actionItems).length > 0 && !hasIncompleteSapActionItems(actionItems);
